<template>
  <div id="app">
    <cabecera />
    <agile :options="agileOptions">

      <img class="slide" src="./assets/jf_home_00.jpg" />
      <img class="slide" src="./assets/jf_home_01.jpg" />
      <img class="slide" src="./assets/jf_home_02.jpg" />
      <img class="slide" src="./assets/jf_home_03.jpg" />
      <img class="slide" src="./assets/jf_home_04.jpg" />
      <img class="slide" src="./assets/jf_home_05.jpg" />
      <img class="slide" src="./assets/jf_home_06.jpg" />
      <img class="slide" src="./assets/jf_home_07.jpg" />
      <img class="slide" src="./assets/jf_home_08.jpg" />
      <img class="slide" src="./assets/jf_home_09.jpg" />
      <img class="slide" src="./assets/jf_home_10.jpg" />
      <img class="slide" src="./assets/jf_home_11.jpg" />
      <img class="slide" src="./assets/jf_home_12.jpg" />
      <img class="slide" src="./assets/jf_home_13.jpg" />
      <img class="slide" src="./assets/jf_home_14.jpg" />
      <img class="slide" src="./assets/jf_home_15.jpg" />
      <img class="slide" src="./assets/jf_home_16.jpg" />

      </agile>
      <pie />
  </div>
</template>

<script>
import { VueAgile } from 'vue-agile'
import Cabecera from './components/Cabecera'
import Pie from './components/Pie'

export default {
  name: 'App',
  components: {
    agile: VueAgile,
    Cabecera,
    Pie
  },
  data () {
    return {
      agileOptions: {
        navButtons: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 6000,
        speed: 1500,
        fade: true,
        infinite: true,
        pauseOnHover: false,
        timing: 'ease-in-out',
      },
    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Roboto&display=swap');
body {
  margin: 0;
  padding: 0;
  color: #333;
  font-size: 12px;
  line-height: 1.6rem;
}
#app {
  font-family: 'Roboto', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  flex-direction: column;

  header {
    height: 80px;
  }
  .agile {
    //max-height: 250px;
    .agile__slides {
      height: 40vh;
      @media (min-width: 768px) {
        height: 70vh;
      }
    }
  }
  footer {

  }
}

.container {
  margin-right: auto;
  margin-left: auto;
  padding-left: 15px;
  padding-right: 15px;

  @media (min-width: 768px) {
    width: 750px;
  }
  @media (min-width: 992px) {
    width: 970px;
  }
  @media (min-width: 1200px) {
    width: 1170px;
  }
}



</style>
